import { Button } from './Button';
import { createSprite } from '../../../utils/GameEngine';
import { SettingState } from '../../../core/managers/SettingsManager';

export class SwitchButton extends Button {
    constructor(private callbackOn: () => any, private callbackOff: () => any, private state: SettingState = SettingState.On) {
        super('switch-off', null, null, true, true, 1);
        if (state === SettingState.Locked) {
            this.disable();
        } else if (state === SettingState.On) {
            this.switchSkin(SettingState.On);
        }
        this.callback = this.onSwitch.bind(this);
        this.pivot.set(0, this.defaultSkin.height / 2);
    }

    protected onPointerUp(): void {
        if (this.clicked) {
            this.clicked = false;
            if (this.resizeAnimation) {
                this.resizeAnimation(this.onSwitch.bind(this));
            } else {
                this.onSwitch();
            }
        }
    }

    private onSwitch(): void {
        if (this.state === SettingState.Off) {
            this.state = SettingState.On;
            this.callbackOn();
        } else {
            this.state = SettingState.Off;
            this.callbackOff();
        }
        this.switchSkin(this.state);
    }

    private switchSkin(state: SettingState): void {
        if (this.defaultSkin) {
            this.defaultSkin.destroy();
        }
        if (state === SettingState.Off) {
            this.defaultSkin = createSprite('switch-off', this);
        } else {
            this.defaultSkin = createSprite('switch-on', this);
        }
    }
}